import React, { useEffect, useRef } from 'react'
import useSearch from '../../../context/search/useSearch'
import getRoute from '../../../../scripts/utils/getRoute'

const SearchDidYouMean: React.FC = () => {
  const { didYouMean, activeTab, productSearchResult, searchResultsArticles, searchResultsPages } = useSearch()
  const containerRef = useRef<HTMLDivElement>(null)

  const hasDidYouMean = didYouMean && Array.isArray(didYouMean) && didYouMean.length > 0;
  const didYouMeanSuggestion = hasDidYouMean ? (didYouMean[0] as unknown as {q: string}).q : null;

  // Add/remove class on parent container (the div that contains both h1 and portal) when component renders/hides
  useEffect(() => {
    if (containerRef.current) {
      // Go up two levels: portal div -> parent div (contains h1 and portal)
      const parentDiv = containerRef.current.parentElement?.parentElement;
      if (parentDiv) {
        if (hasDidYouMean && didYouMeanSuggestion) {
          // Check if we should show (has results)
          const shouldShow = !(
            (activeTab === 'products' && productSearchResult.total === 0) ||
            (activeTab === 'blogs' && searchResultsArticles.length === 0) ||
            (activeTab === 'pages' && searchResultsPages.length === 0)
          );

          if (shouldShow) {
            parentDiv.classList.add('has-did-you-mean');
          } else {
            parentDiv.classList.remove('has-did-you-mean');
          }
        } else {
          parentDiv.classList.remove('has-did-you-mean');
        }
      }
    }

    // Cleanup on unmount
    return () => {
      if (containerRef.current?.parentElement?.parentElement) {
        containerRef.current.parentElement.parentElement.classList.remove('has-did-you-mean');
      }
    };
  }, [hasDidYouMean, didYouMeanSuggestion, activeTab, productSearchResult, searchResultsArticles, searchResultsPages]);

  // Show nothing if no didYouMean suggestion
  if (!hasDidYouMean || !didYouMeanSuggestion) {
    return null;
  }

  // Only show if there are results to display
  if (activeTab === 'products' && productSearchResult.total === 0) {
    return null;
  }
  if (activeTab === 'blogs' && searchResultsArticles.length === 0) {
    return null;
  }
  if (activeTab === 'pages' && searchResultsPages.length === 0) {
    return null;
  }

  return (
    <div ref={containerRef} className="search-did-you-mean">
      Did you mean&nbsp;
      <a href={`${getRoute()}search?q=${encodeURIComponent(didYouMeanSuggestion)}`}>{didYouMeanSuggestion}</a>?
    </div>
  )
}

export default SearchDidYouMean
